import type { Auth0Result } from 'auth0-js'
import type { UserSignupDetails } from 'hooks/useAuth'

export const WANDA_JWT_TOKEN = 'WANDA_JWT_TOKEN'
export const WANDA_LAST_ROUTE = 'WANDA_LAST_ROUTE'
export const IS_LOGGED_IN = 'isLoggedIn'
export const IS_NOTIFICATION_DISMISSED = 'isNotificationDismissed'
export const STORAGE_FLOW_STATE = 'storageFlowState'
export const EDIT_STORAGE_FLOW_STATE = 'editStorageFlowState'
export const RETURN_FLOW_STATE = 'returnFlowState'
export const PACKAGING_FLOW_STATE = 'packagingFlowState'
export const SQUARE_METER_FLOW_STATE = 'squareMeterFlowState'
export const AUTH_RESULT = 'authResult'
export const UI_STATE = 'uiState'
export const STORAGE_UNIT_FLOW_STATE = 'storageUnitFlowState'
export const INSTALL_PROMPT_DISMISSED_AT = 'installPromptDismissedAt'
/** Metadata handed to Auth0 as appState when we log in by redirect instead of popup. */
export const AUTH_REDIRECT_STATE = 'authRedirectState'

export interface LocalStorageState {
  [AUTH_RESULT]: { authResult: Auth0Result; metadata?: UserSignupDetails }
}
